import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/Button";
import { Link, useLocation } from "react-router-dom";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/Card";
import {
  Users,
  Briefcase,
  DollarSign,
  Zap,
  FileText,
  Award,
  MessageSquare,
  CheckCircle2,
} from "lucide-react";

export default function DevenirRecruteurPartenaire() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      <main className="flex-grow">
        <section className="bg-gradient-to-r from-blue-50 to-indigo-50 pt-[154px] pb-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Devenez recruteur freelance chez J'❤️ Intérim
            </h1>
            <p className="text-lg text-gray-700">
              Exercez votre passion pour le recrutement en toute autonomie, avec
              le soutien d'un réseau établi. Gérez vos contacts, nous vous
              apportons des outils.
            </p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">
              Un partenariat flexible et accompagné
            </h2>
            <div className="grid md:grid-cols-2 gap-8 items-start">
              <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                <CardHeader className="pb-4">
                  <div className="flex justify-center mb-4">
                    <div className="p-3 bg-blue-100 rounded-full">
                      <Users className="h-10 w-10 text-blue-600" />
                    </div>
                  </div>
                  <CardTitle className="text-2xl font-semibold text-blue-700 text-center">
                    Votre rôle
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-gray-700 space-y-3">
                  <p className="text-center mb-4 text-justify">
                    En tant que freelance, vous êtes au cœur de l'action
                    stratégique et opérationnelle de vos recrutements :
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <CheckCircle2 className="h-5 w-5 text-blue-500 mr-2 mt-1 flex-shrink-0" />
                      <span>
                        <strong>Sourcing :</strong> Dénichez les meilleurs
                        talents pour les besoins de vos clients en utilisant des
                        stratégies multicanales.
                      </span>
                    </li>

                    <li className="flex items-start">
                      <CheckCircle2 className="h-5 w-5 text-blue-500 mr-2 mt-1 flex-shrink-0" />
                      <span>
                        <strong>Développement Commercial :</strong> En totale
                        autonomie, développez votre propre portefeuille client
                        avec les outils CRM, mis à votre disposition par nos
                        soins.
                      </span>
                    </li>
                    <li className="flex items-start">
                      <CheckCircle2 className="h-5 w-5 text-blue-500 mr-2 mt-1 flex-shrink-0" />
                      <span>
                        <strong>Gestion de votre temps :</strong> En tant que
                        recruteur freelance, vous organisez votre emploi du
                        temps de manière autonome en équilibrant vie privée et
                        vie professionnelle.
                      </span>
                    </li>
                    <li className="flex items-start">
                      <CheckCircle2 className="h-5 w-5 text-blue-500 mr-2 mt-1 flex-shrink-0" />
                      <span>
                        <strong>Fidélisation :</strong> Accompagnez vos
                        candidats et vos clients en leur assurant un recrutement
                        réussi.
                      </span>
                    </li>
                  </ul>
                </CardContent>
              </Card>
              <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                <CardHeader className="pb-4">
                  <div className="flex justify-center mb-4">
                    <div className="p-3 bg-blue-100 rounded-full">
                      <Briefcase className="h-10 w-10 text-blue-600" />
                    </div>
                  </div>
                  <CardTitle className="text-2xl font-semibold text-blue-700 text-center">
                    Notre rôle
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-gray-700 space-y-3">
                  <p className="text-center mb-4">
                    Nous vous fournissons les leviers pour maximiser votre
                    succès :
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <CheckCircle2 className="h-5 w-5 text-blue-500 mr-2 mt-1 flex-shrink-0 text-justify" />
                      <span>
                        <strong>Base de CVs Mutualisée :</strong> Accédez à
                        notre vivier de talents qualifiés pour accélérer vos
                        recherches.
                      </span>
                    </li>
                    <li className="flex items-start">
                      <CheckCircle2 className="h-5 w-5 text-blue-500 mr-2 mt-1 flex-shrink-0" />
                      <span>
                        <strong>Outils internes :</strong> Bénéficiez de nos
                        méthodes de travail, de nos outils de sourcing et de
                        notre application "Mon intérim".
                      </span>
                    </li>
                    <li className="flex items-start">
                      <CheckCircle2 className="h-5 w-5 text-blue-500 mr-2 mt-1 flex-shrink-0" />
                      <span>
                        <strong>Support Administratif & Contractuel :</strong>{" "}
                        Un service dedié à la facturation et à la gestion
                        contractuelle pour vous concentrer sur le recrutement et
                        la prospection.
                      </span>
                    </li>
                    <li className="flex items-start">
                      <CheckCircle2 className="h-5 w-5 text-blue-500 mr-2 mt-1 flex-shrink-0" />
                      <span>
                        <strong>Force d'une Marque Reconnue :</strong>{" "}
                        Appuyez-vous sur la notoriété et la crédibilité du
                        groupe J'M Intérim pour développer votre activité.
                      </span>
                    </li>
                  </ul>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* Your Advantages Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">
              Les avantages concrets de notre collaboration
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  icon: <DollarSign className="h-10 w-10 text-blue-600 mb-4" />,
                  title: "Rémunération Motivante",
                  text: "Un commissionnement attractif et transparent sur chaque recrutement réussi, valorisant directement votre expertise et vos résultats.",
                },
                {
                  icon: <Zap className="h-10 w-10 text-blue-600 mb-4" />,
                  title: "Autonomie & Flexibilité",
                  text: "Gérez votre temps comme vous l'entendez. Idéal pour un équilibre vie professionnelle/personnelle optimal.",
                },
                {
                  icon: <FileText className="h-10 w-10 text-blue-600 mb-4" />,
                  title: "Allègement Administratif",
                  text: "Concentrez-vous sur votre cœur de métier : le recrutement. Nous pouvons simplifier votre quotidien en gérant l'administratif.",
                },
                {
                  icon: <Users className="h-10 w-10 text-blue-600 mb-4" />,
                  title: "Accès à des Ressources Clés",
                  text: "Profitez de notre base de CVs, de missions potentielles et d'outils pour développer votre activité plus rapidement et efficacement.",
                },
                {
                  icon: <Award className="h-10 w-10 text-blue-600 mb-4" />,
                  title: "Développement Professionnel",
                  text: "Montez en compétences, gagnez en crédibilité et élargissez votre réseau en vous associant à un nom reconnu du secteur.",
                },
                {
                  icon: (
                    <MessageSquare className="h-10 w-10 text-blue-600 mb-4" />
                  ),
                  title: "Support et Esprit de Réseau",
                  text: "Rejoignez une communauté de professionnels, bénéficiez de conseils, partagez vos expériences et ne soyez plus seul(e) dans votre activité.",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="bg-gray-50 p-6 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col text-center items-center"
                >
                  {item.icon}
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm text-justify">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Who is this for Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-12 text-center">
              Ce partenariat est fait pour vous si...
            </h2>
            <div className="max-w-3xl mx-auto bg-white p-8 rounded-xl shadow-xl">
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start">
                  <CheckCircle2 className="h-6 w-6 text-blue-500 mr-3 mt-1 flex-shrink-0" />
                  <span>
                    <strong>
                      Vous êtes un recruteur expérimenté ou consultant RH :
                    </strong>{" "}
                    Vous souhaitez exercer votre expertise en proposant plus de
                    services à vos clients (comme l'intérim).
                  </span>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-6 w-6 text-blue-500 mr-3 mt-1 flex-shrink-0" />
                  <span>
                    <strong>
                      Vous êtes professionnel avec une forte fibre commerciale
                      et un attrait pour le recrutement :
                    </strong>{" "}
                    Vous avez un talent pour la relation client et la détection
                    de potentiels.
                  </span>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-6 w-6 text-blue-500 mr-3 mt-1 flex-shrink-0" />
                  <span>
                    <strong>
                      Vous êtes une personne désireuse de se lancer ou se
                      (re)convertir dans le recrutement :
                    </strong>{" "}
                    Vous avez un excellent réseau professionnel, une forte
                    motivation et le sens du service.
                  </span>
                </li>
                <li className="flex items-start">
                  <CheckCircle2 className="h-6 w-6 text-blue-500 mr-3 mt-1 flex-shrink-0" />
                  <span>
                    <strong>
                      Vous aspirez à l'entrepreneuriat dans le recrutement
                    </strong>{" "}
                    mais souhaitez minimiser les risques et les charges
                    initiales.
                  </span>
                </li>
              </ul>
              <p className="mt-8 text-center text-gray-600 italic font-semibold">
                Votre engagement, votre sens du résultat, votre éthique et votre
                capacité à créer des relations de confiance sont les piliers de
                notre future réussite commune.
              </p>
            </div>
          </div>
        </section>
        {/* Call to Action Section */}
        <section className=" bg-gradient-to-r from-blue-50 to-indigo-50 pt-20 pb-10">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Prêt à lancer votre activité de recruteur en freelance avec J'❤️
              Intérim ?
            </h2>
            <p className="text-xl mb-10 max-w-2xl mx-auto text-justify">
              Discutons ensemble de votre projet, de vos ambitions et de la
              manière dont nous pouvons collaborer pour une réussite mutuelle et
              durable.
            </p>
            <Link to="/contact">
              <Button
                size="lg"
                variant="secondary"
                className="bg-white text-blue-700 hover:bg-gray-100 font-semibold text-lg px-10 py-4 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                Je candidate en tant que freelance
              </Button>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
